import React from 'react';
import InfoTable from '../../../../../components/table/InfoTable';
import './BrandDetailOrderBalanceCalculate.scss';
import { useQuery } from '@tanstack/react-query';
import { settlementQuery } from '../../../../settlement/queries';

type Props = {
  brandId: string;
};

const BrandDetailOrderBalanceCalculate = ({ brandId }: Props): JSX.Element => {
  const { data } = useQuery(
    settlementQuery.totalByStatus({ brandId: Number(brandId), statuses: ['completed', 'hold', 'ready'] }),
  );

  const { totalSettlements } = data ?? {};

  const ready = totalSettlements?.find(({ status }) => status === 'ready');
  const completed = totalSettlements?.find(({ status }) => status === 'completed');
  const hold = totalSettlements?.find(({ status }) => status === 'hold');

  return (
    <div className="brand-detail-order-balance-calculate-content">
      {/* 정산 정보 */}
      <div className="brand-detail-order-balance-calculate-section">
        <div className="title">정산 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">누적 정산대기금액</td>
              <td className="tc">{ready?.totalAmount ? ready.totalAmount.toLocaleString() : 0}</td>
              <td className="label tc">누적 정산완료금액</td>
              <td className="tc">{completed?.totalAmount ? completed.totalAmount.toLocaleString() : 0}</td>
            </tr>
            <tr>
              <td className="label tc">누적 지급보류금액</td>
              <td className="tc">{hold?.totalAmount ? hold.totalAmount.toLocaleString() : 0}</td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </div>
  );
};

export default BrandDetailOrderBalanceCalculate;
